'use client';

import { useWindowSize } from '@/src/hooks';
import { useEffect, useState } from 'react';
import { isMobile, isBrowser, isTablet } from 'react-device-detect';

export const useCheckIsMobileView = () => {
  const [isMobileView, setIsMobileView] = useState<boolean>(false);
  const [isTabletView, setIsTabletView] = useState<boolean>(false);
  const { width, height } = useWindowSize();

  useEffect(() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const tabletQuery = window.matchMedia(
      '(min-device-width: 768px) and (max-device-width: 1224px)'
    );
    const tabletProProQuery = window.matchMedia(
      '(min-width: 1024px) and (max-width: 1366px) and (min-height:1024px) and (max-height:1366px)'
    );
    if (mobileQuery.matches) {
      setIsMobileView(true);
    } else {
      setIsMobileView(false);
    }
    if (isTablet || tabletQuery.matches || tabletProProQuery.matches) {
      setIsTabletView(true);
    } else {
      setIsTabletView(false);
    }

    if (tabletProProQuery.matches && isBrowser) {
      setIsTabletView(false);
    }
  }, [isMobile, isBrowser, isTablet, width]);

  return {
    isMobileView,
    isTabletView,
    width,
    height,
  };
};

export default function useOnlineStatus() {
  const [status, setStatus] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleOnline = () => {
        setStatus(true);
      };

      const handleOffline = () => {
        setStatus(false);
      };

      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);

      return () => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
      };
    }
  }, []);

  return status;
}

export const useDevToolsMobileEmulation = () => {
  const [isEmulatedMobile, setIsEmulatedMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const checkEmulation = () => {
        const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(
          navigator.userAgent
        );
        const isTouchEnabled =
          'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isViewportSmall = window.innerWidth <= 767; // Mobile breakpoint

        setIsEmulatedMobile(isViewportSmall && isMobileUA && isTouchEnabled);
      };

      checkEmulation(); // Initial check
      window.addEventListener('resize', checkEmulation); // Listen for resize events

      return () => window.removeEventListener('resize', checkEmulation);
    }
  }, []);

  return isEmulatedMobile;
};
